<template>
  <span class="caption">{{ captionText }}</span>
</template>

<script>
export default {
  mixins: [],
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  data: () => ({}),
  computed: {
    insightSubjectiveMetric() {
      return (
        this.category.catInsightMetric == 0 ||
        this.category.catInsightMetric == 1
      );
    },
    insightMetricType() {
      switch (this.category.catInsightMetric) {
        case 0:
          return "sentiment";
        case 1:
          return "emotion";
        case 2:
          return "silence";
        default:
          return "overtalk";
      }
    },
    captionText() {
      let metricType = this.insightMetricType;
      let scString = metricType.charAt(0).toUpperCase() + metricType.slice(1);

      let locationText = "";
      if (this.insightSubjectiveMetric) {
        locationText = this.category.catLocationBeginning
          ? " Beginning "
          : " End ";
      }

      switch (this.category.catInsightChannel) {
        case 0:
          return " Agent " + locationText + scString;
        case 1:
          return " Customer " + locationText + scString;
        default:
          return " Overall " + locationText + scString;
      }
    }
  },
  methods: {}
};
</script>
<style scoped></style>
